import axiosGo from "./axiosGo";

export const tierApi = {        
    getTiers: () => {
        const url = `tier/api/v1/tiers`;
        return axiosGo.get(url);
    },
};
